import React from 'react';
import aviaoPremiacao from 'assets/img/2026/aviao_premiacao.png';
import cartaoPremiacao from 'assets/img/2026/cartao_premiacao.png';
import './PremiacoesSectionElbb.scss';

/**
 * Seção "Conheça as premiações" — mesma identidade da HomePublic:
 * - Full-bleed (cada card vai até a borda lateral correspondente da viewport)
 * - PNGs com estrelas usados como background do card
 * - Texto alinhado de acordo com a ilustração (avião à direita, cartão à esquerda)
 */
export const PremiacoesSectionElbb: React.FC = () => (
  <section className="premiacoes-elbb-section" aria-labelledby="premiacoes-elbb-title">
    <h2 className="premiacoes-elbb-section__title" id="premiacoes-elbb-title" tabIndex={0}>
      Conheça as premiações
    </h2>
    <div className="premiacoes-elbb-grid">
      <div
        className="premiacao-elbb-card premiacao-elbb-card--aviao"
        style={{ backgroundImage: `url(${aviaoPremiacao})` }}
        tabIndex={0}
        aria-label="Ilustração do prêmio Experiências BB"
      >
        <div className="premiacao-elbb-card__body premiacao-elbb-card__body--right">
          <h3 className="premiacao-elbb-card__title" tabIndex={0}>Prêmio Individual Experiências BB</h3>
          <p className="premiacao-elbb-card__description" tabIndex={0}>
            Viagem nacional, com acompanhante, com direito a uma <br /> experiência marcante e especial com a marca BB. <br />
          </p>
        </div>
      </div>

      <div
        className="premiacao-elbb-card premiacao-elbb-card--cartao"
        style={{ backgroundImage: `url(${cartaoPremiacao})` }}
        tabIndex={0}
        aria-label="Ilustração do cartão premiação na modalidade pré-pago"
      >
        <div className="premiacao-elbb-card__body premiacao-elbb-card__body--left">
          <h3 className="premiacao-elbb-card__title" tabIndex={0}>Cartão premiação na modalidade pré-pago</h3>
          <p className="premiacao-elbb-card__description" tabIndex={0}>
            Para todos os participantes das iniciativas premiadas:<br />
            <strong>1º lugar:</strong> até R$ 3 mil • <strong>2º lugar:</strong> até R$ 2 mil • <strong>3º lugar:</strong> até R$ 1,2 mil
          </p>
        </div>
      </div>
    </div>
  </section>
);
